import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';
import { bindBackgroundUploadQueryClient, getBackgroundUploadTasks, getFocusedBackgroundUploadId, getLocalUploadSources, hasUnfinishedBackgroundUploads, restoreBackgroundUploads, subscribeBackgroundUploads, } from '@/features/upload-asset/model/backgroundUploadQueue';
/**
 * 订阅后台上传队列，并在挂载时恢复本机断点。
 * @returns 当前任务和本地播放地址
 */
export function useBackgroundUploadSnapshot() {
    const queryClient = useQueryClient();
    /** 队列在模块里，用版本号把变化送进渲染。 */
    const [version, setVersion] = useState(0);
    useEffect(() => {
        bindBackgroundUploadQueryClient(queryClient);
        void restoreBackgroundUploads();
        return subscribeBackgroundUploads(() => {
            setVersion((current) => current + 1);
        });
    }, [queryClient]);
    useEffect(() => {
        /** 还有未完成上传时，刷新或关闭页面前让浏览器提示。 */
        const handleBeforeUnload = (event) => {
            if (!hasUnfinishedBackgroundUploads())
                return;
            event.preventDefault();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    return useMemo(() => {
        /** 版本号只用来在队列变化后重新读取模块里的任务。 */
        const snapshotVersion = version;
        return {
            tasks: snapshotVersion >= 0 ? getBackgroundUploadTasks() : [],
            sources: getLocalUploadSources(),
            focusedAssetId: snapshotVersion >= 0 ? getFocusedBackgroundUploadId() : null,
        };
    }, [version]);
}
